import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { UserContext } from "../context/UserContext";

const Prochainement = () => {

  const { t } = useTranslation();
  const { user } = useContext(UserContext)

  const [chances, setChances] = useState(0)

  useEffect(() => {
    let formData = new FormData();
    formData.append("action", "get_user");

    fetch(process.env.REACT_APP_API_URL + '/index.php',
      {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${user.jwt}`
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.success){
          const user = json.data
          const cards = Object.values(user.cartes).filter(value => value === true).length
          let bonus = 0
          let multiplicateur = 1

          if (cards >= 3 && cards < 6)
            bonus = 1
          else if (cards >= 6 && cards < 8)
            bonus = 2
          else if (cards >= 8) {
            bonus = 2
            multiplicateur = 2
          }

          const chances = (cards + bonus) * multiplicateur
          setChances(chances)
        }
      });
  }, []);



  return (
    <div className={"strate footer"} id={"prochainementStrate"}>
      <h1 dangerouslySetInnerHTML={{ __html: t("prochainement_prochainement") }} />

      <div className={"visuel"} />

      <div className={"subtitle"} dangerouslySetInnerHTML={{ __html: t("prochainement_subtitle", { chances : chances}) }} />

      <p dangerouslySetInnerHTML={{ __html: t("prochainement_paragraph") }} />
    </div>
  );
}
export default Prochainement;
